import { useState } from "react";
import { useQuery } from "@apollo/react-hooks";

import { QUERY_GET_STORE } from "apollo/module-operations/store";
import { Store } from "@/types";

import { useUser } from "../auth";

const useStore = (): { store: Store; loading: boolean } => {
    const { accountId, storeId } = useUser();
    const [store, setStore] = useState<Store>();

    const { loading } = useQuery(QUERY_GET_STORE, {
        skip: !accountId || !storeId,
        fetchPolicy: "network-only",
        variables: {
            account_id: accountId,
            store_id: storeId,
        },
        onError: error => {
            console.log({ error });
        },
        onCompleted: data => {
            setStore(data?.getStore);
        },
    });

    return { store, loading };
};

export { useStore };
